<script lang="ts">
export default {
  name: "BaseProgressBar",
};
</script>

<script setup lang="ts">
export type Props = {
  progress: number;
};

withDefaults(defineProps<Props>(), { progress: 0 });
</script>

<template>
  <div class="progress">
    <div
      class="progress-bar"
      role="progressbar"
      :aria-valuenow="progress"
      aria-valuemin="0"
      aria-valuemax="100"
      :style="{ width: `${progress}%` }"
    >
      {{ Math.round(progress) }}%
    </div>
  </div>
</template>
